enum RATING {
  BAD = "bad",
  AVERAGE = "average",
  GOOD = "good",
}

export default RATING;
